import axios, {AxiosResponse} from "axios";
import {CashFlow} from "@/model/CashFlow";

const PATH = "/statistics";

function cashFlowRequest(cashFlow: CashFlow): CashFlow {
    return {
        type: cashFlow.type,
        month: cashFlow.month,
        amount: cashFlow.amount,
        description: cashFlow.description || undefined
    };
}

export default {
    createCashFlow (orderUuid: string, cashFlow: CashFlow): Promise<AxiosResponse<CashFlow>> {
        return axios.post(`/v2/orders/${orderUuid}/cash-flows`, cashFlowRequest(cashFlow));
    },
    updateCashFlow (orderUuid: string, cashFlowId: string, cashFlow: CashFlow): Promise<AxiosResponse<CashFlow>> {
        return axios.put(`/v2/orders/${orderUuid}/cash-flows/${cashFlowId}`, cashFlowRequest(cashFlow));
    },
    deleteCashFlow (orderUuid: string, cashFlowId: string) {
        return axios.delete(`/v2/orders/${orderUuid}/cash-flows/${cashFlowId}`);
    },
    getCashFlows (orderUuid: string): Promise<AxiosResponse<{ cashFlows: Array<CashFlow> }>> {
        return axios.get(`/v2/orders/${orderUuid}/cash-flows`);
    },
    getEmployeePerformances(yearMonth: string) {
        return axios.get(`${PATH}/employee-performances`, {
            params: {
                yearMonth: yearMonth
            }
        });
    },
    getDailyStatistic(orderIds: Array<number>, employeeIds: Array<number>, date: string) {
        return axios.get(`${PATH}/employees/daily`, {
            params: {
                orderIds: orderIds.join(","),
                employeeIds: employeeIds.join(","), 
                date: date
            }
        });
    }
};
